import axios from '../axios'

// 生徒のLMS属性（担当講師/レベル）設定（admin）
// payload = { assigned_teacher_id?, level? }
const patchUserLmsApi = async (userId, payload) => {
  return await axios.patch(`api/lms/users/${userId}/lms`, payload)
}

export default patchUserLmsApi
